import React from "react";

import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type DeviceSourcesStatusProps<Source> = {
  sources: Source[];
  noDeviceText: string;
  deviceDetectedText: string;
  manyDevicesDetectedText: string;
};

export const DeviceSourcesStatus = <Source,>({
  sources,
  noDeviceText,
  deviceDetectedText,
  manyDevicesDetectedText,
}: DeviceSourcesStatusProps<Source>): React.ReactElement => {
  switch (sources.length) {
    case 0:
      return <Typography color="warning">{noDeviceText}</Typography>;
    case 1:
      return <Typography color="success">{deviceDetectedText}</Typography>;
    default:
      return <Typography color="error">{manyDevicesDetectedText}</Typography>;
  }
};
